import 'promise-polyfill/src/polyfill';
import 'unfetch/polyfill';
import 'abortcontroller-polyfill';

import Vue from 'vue';
import CoacPlugin from '@mgo/core/src/plugins/coac';
import DisputePlugin from '@mgo/core/src/plugins/dispute';
import { bootstrapSession } from '@mgo/core/src/class/session';
import {
  SESSION_ACTIVITY_EVENT,
  SESSION_REQUEST_STARTED_EVENT,
  SESSION_REQUEST_FAILED_EVENT,
  SESSION_UNAVAILABLE_EVENT,
} from '@mgo/core/src/sessionState';
import {
  startInactivityTimer,
  stopInactivityTimer,
  handleRequestStarted,
  handleActivity,
  handleRequestFailed,
} from '@mgo/core/src/sessionInactivityTimer';
import segment from '@mgo/core/src/utils/segmentRudderStack';
import App from './App.vue';
import router from './router';
import store from './store';
import VueSanitize from 'vue-sanitize';
import './css/index.css';

segment();

Vue.config.productionTip = false;

Vue.use(VueSanitize,
  {
    // Options
    allowedTags: ['b', 'i', 'em', 'strong', 'a', 'p', 'div', 'span', 'table', 'tbody', 'thead', 'th', 'tr', 'td', 'ul', 'ol', 'li', 'br', 'hr'],
    allowedAttributes: {
      a: ['href'],
      img: ['src', 'alt'],
      '*': ['class', 'style', 'id', 'name', 'title', 'data-*'],
    },
  }
);

Vue.use(CoacPlugin, {
  api: '/api/mgo',
  postbackURL: `${window.location.origin}/mgoc/action?payment=success`,
});
Vue.use(DisputePlugin, {
  api: '/api/mgo',
});

// MGOD-11701: bootstrap the BFF session before mounting.
bootstrapSession()
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error('[coac] session bootstrap failed', err);
    const root = document.getElementById('app');
    if (root) root.innerHTML = '<p style="font-family:sans-serif;padding:2rem">Unable to start session. Please refresh the page or try again later.</p>';
    throw err;
  })
  .then(() => {
    new Vue({
      router,
      store,
      created() {
        window.addEventListener(SESSION_REQUEST_STARTED_EVENT, handleRequestStarted);
        window.addEventListener(SESSION_ACTIVITY_EVENT, handleActivity);
        window.addEventListener(SESSION_REQUEST_FAILED_EVENT, handleRequestFailed);
        window.addEventListener(SESSION_UNAVAILABLE_EVENT, this.handleSessionUnavailable);
        startInactivityTimer();
      },
      beforeDestroy() {
        window.removeEventListener(SESSION_REQUEST_STARTED_EVENT, handleRequestStarted);
        window.removeEventListener(SESSION_ACTIVITY_EVENT, handleActivity);
        window.removeEventListener(SESSION_REQUEST_FAILED_EVENT, handleRequestFailed);
        window.removeEventListener(SESSION_UNAVAILABLE_EVENT, this.handleSessionUnavailable);
        stopInactivityTimer();
      },
      methods: {
        handleSessionUnavailable() {
          stopInactivityTimer();

          this.$coac.reset();
          this.$dispute.reset();
          this.$store.dispatch('RESET_STATE');

          if (this.$route.name !== 'session-unavailable') {
            this.$router.replace({ name: 'session-unavailable' }).catch((err) => {
              // Ignore NavigationDuplicated errors from concurrent session-unavailable events
              if (err.name !== 'NavigationDuplicated') {
                throw err;
              }
            });
          }
        },
      },
      render: (h) => h(App),
    }).$mount('#app');
  });
